// removed by extract-text-webpack-plugin
module.exports = {"Card":"Card--2Gp9A","CardHeader":"CardHeader--3XwTX","CardContent":"CardContent--17nuc","CardFooter":"CardFooter--2j_AF"};